import { createSlice, PayloadAction, createSelector } from 'redux-starter-kit';
import { Resources, Mutations } from '@erecruit/types';

import { selectAppState } from '../../../App/state/selectors';

export interface MatchSearchPayload {
  data: Resources.MatchSearch[];
  totalCount: number;
}

export interface MatchSearchFilterData {
  companies: Resources.Company[];
  facilityDepartments: Resources.FacilityDepartment[];
  positionOwners: Resources.Contact[];
  positions: Resources.Position[];
  positionTypes: Resources.PositionType[];
  statuses: Resources.MatchStatus[];
  worksites: Resources.Worksite[];
}

export interface MatchSearchState extends MatchSearchPayload {
  isLoading: boolean;
  isLoadingFilterData: boolean;
  exporting?: boolean;
  error?: string;
  filterData?: MatchSearchFilterData;
}

const initialState: MatchSearchState = {
  isLoading: false,
  isLoadingFilterData: false,
  data: [],
  totalCount: 0,
};

const MatchSearchSlice = createSlice({
  slice: 'matchSearch',
  initialState: initialState,
  reducers: {
    searchMatches(
      state,
      // eslint-disable-next-line
      action: PayloadAction<Resources.MatchSearchParams>,
    ) {
      state.isLoading = true;
    },
    searchMatchesSuccess(state, action: PayloadAction<MatchSearchPayload>) {
      const { data, totalCount } = action.payload;
      state.data = data;
      state.totalCount = totalCount;
      state.isLoading = false;
    },
    searchMatchesFail(state, action: PayloadAction<string>) {
      state.error = action.payload;
    },
    getFilterData(state) {
      state.isLoadingFilterData = true;
    },
    getFilterDataSuccess(state, action: PayloadAction<MatchSearchFilterData>) {
      state.filterData = action.payload;
      state.isLoadingFilterData = false;
    },
    getFilterDataFail(state, action: PayloadAction<string>) {
      state.error = action.payload;
    },
    exportMatches(
      state,
      // eslint-disable-next-line
      action: PayloadAction<
        Pick<Mutations.ExportMatchSearchParams, 'columns'> & {
          params: Mutations.ExportMatchSearchParams['matchSearchParams'];
        }
      >,
    ) {
      state.exporting = true;
    },
    // eslint-disable-next-line
    exportMatchesSuccess(state, action: PayloadAction) {
      state.exporting = false;
    },
    exportMatchesFail(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.exporting = false;
    },
  },
});

const {
  actions,
  reducer,
  selectors: { getMatchSearch },
} = MatchSearchSlice;

export const {
  searchMatches,
  searchMatchesFail,
  searchMatchesSuccess,
  getFilterData,
  getFilterDataSuccess,
  getFilterDataFail,
  exportMatches,
  exportMatchesFail,
  exportMatchesSuccess,
} = actions;
export const selectors = {
  selectMatchSearchState: createSelector([selectAppState], getMatchSearch),
};
export default reducer;
